@if (shouldShowTrace) {
  <div class="mb-4">
    <!-- Simple thinking indicator when streaming with no traces yet -->
    @if (traces.length === 0 && isStreaming) {
      <div class="flex items-center gap-2 px-3 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm w-fit">
        <div class="w-1.5 h-1.5 rounded-full bg-gray-600 dark:bg-gray-400 animate-pulse"></div>
        <span class="text-gray-700 dark:text-gray-300">Thinking...</span>
      </div>
    }

    <!-- Collapsed view when not expanded -->
    @if (traces.length > 0 && !isExpanded) {
      <div (click)="isExpanded = true"
        class="flex items-center gap-2 px-3 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors text-sm w-fit">
        @if (isStreaming) {
          <div class="w-1.5 h-1.5 rounded-full bg-gray-600 dark:bg-gray-400 animate-pulse"></div>
        }
        <span class="text-gray-700 dark:text-gray-300" [class.text-gray-600]="!isStreaming" [class.dark:text-gray-400]="!isStreaming">
          {{ isStreaming ? currentStepMessage : 'Thought for ' + thinkingTime + 's' }}
        </span>
      </div>
    }

    <!-- Expanded view -->
    @if (traces.length > 0 && isExpanded) {
      <div>
        <div (click)="isExpanded = false"
          class="inline-flex items-center gap-2 px-3 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg cursor-pointer transition-colors text-sm mb-3">
          <span class="text-gray-600 dark:text-gray-400">
            {{ isStreaming ? 'Thinking...' : 'Thought for ' + thinkingTime + 's' }}
          </span>
        </div>

        <div class="space-y-0 relative">
          @for (step of thinkingSteps; track step.idx; let last = $last; let first = $first) {
            <div class="flex gap-4 min-h-[32px] animate-fadeIn">
              <!-- Left: Timeline logic -->
              <div class="flex flex-col items-center w-3 shrink-0">
                <!-- Top Line (to connect to previous dot) -->
                <div class="w-px h-2 bg-gray-300 dark:bg-gray-700" [class.invisible]="first"></div>

                <!-- Dot -->
                <div [class]="'w-1.5 h-1.5 rounded-full shrink-0 ' +
                  (isStreaming && last ? 'bg-gray-600 dark:bg-gray-400 animate-pulse' : 'bg-gray-400 dark:bg-gray-600')">
                </div>

                <!-- Bottom Line (to connect to next dot) -->
                <div class="w-px flex-1 bg-gray-300 dark:bg-gray-700" [class.invisible]="last"></div>
              </div>

              <!-- Right: Step text -->
              <div class="pb-4">
                <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  {{ step.message }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
